import axios from "axios";
import {header} from "./header"

export const GenerateDocSeriesFormat = async (transid, IsUpdate) => {
  const orgCode = localStorage.getItem('OrgCode');  
  const subOrg =  localStorage.getItem('LocCode');  
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/SeriesGeneration/GenerateDocSeriesFormat?TrnTypeId=${transid}&SubOrgCode=${subOrg}&OrgCode=${orgCode}&IsUpdate=${IsUpdate}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const UpdateNextSeries = async (transid) => {
  const orgCode = localStorage.getItem('OrgCode');  
  const subOrg = localStorage.getItem('LocCode');  
  try {
    const response = await axios.get(`${process.env.REACT_APP_SALE_BASE_URL}/api/SeriesGeneration/UpdateNextSeries?TrnTypeId=${transid}&SubOrgCode=${subOrg}&OrgCode=${orgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GetRoleAccess = async () =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetRoles?OrgCode=${localStorage.getItem('OrgCode')}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GetRoleDetails = async (obj) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetRoleDetails?Id=${obj.Id}&OrgCode=${obj.OrgCode}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const SaveRolesAndMapping = async (obj) =>{
  try {
    const response = await axios.post(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/SaveRoleAndMapping`, obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}
export const getgroupsList = async (obj) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetGroupList?OrgCode=${obj.Id}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const ActivateORDeactivateGroup = async (obj) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/ActivateORDeactivateGroup?Id=${obj.Id}&OrgCode=${obj.OrgCode}&IsActivate=${obj.IsActivate}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const ActivateORDeactivateRole = async (obj) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/ActivateORDeactivateRole?Id=${obj.Id}&OrgCode=${obj.OrgCode}&IsActivate=${obj.IsActivate}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}


export const sendPassEmail = async (obj) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/OrgAPI/SendPasswordCreationEmail?email=${obj.email}&orgName=${obj.orgName}&userType=${obj.userType}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GenerateOTPEmail = async (obj) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}Organisation/GenerateOTP?SendTo=${obj.SendTo}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}


export const VerifyOTPEmail = async (obj) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}Organisation/VerifyOTP?OTP=${obj.OTP}&SendTo=${obj.SendTo}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}


export const ForgotPwdEmail = async (Obj) =>{
  try {
    const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}Organisation/ForgotPwd`, Obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}


export const UserChangePassword = async (Obj) =>{
  try {
    const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}Organisation/UserChangePassword?Password=${Obj.Password}&PasswordSalt=${Obj.PasswordSalt}&Sendto=${Obj.Sendto}`,'',{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

///organisation/IsUserExists?userName="
export const isUserExists = async(Obj)=>{
  try{
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}organisation/IsUserExists?userName=${Obj.userName}`,{headers:header()});
    return response;
  }catch(error){
    return error.response
  }
}

export const IsEmailExists = async (OBJ) => {
  try{
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}organisation/IsEmailExists?emailId=${OBJ.email}`,{headers:header()});
    return response; 
  }catch (error){
    return error.response;
  }
}

export const GetCaSignUp = async () => {
  try{
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/GetCaSignUp?OrgCode=${localStorage.getItem("OrgCode")}`,{headers:header()});
    return response; 
  }
  catch (error){
    return error.response;
  }
}

export const GetAllPartnerTypes= async () => {
  try{
    const response = await axios.get(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/orgapi/GetAllPartnerTypes`,{headers:header()});
    return response; 
  }
  catch (error){
    return error.response;
  }
}

export const SaveCAOrgAssociation = async (Obj) => {
  try{
    const response = await axios.post(`${process.env.REACT_APP_lOCAL_AUTHORITY}api/UserAPI/SaveCAOrgAssociation`,Obj,{headers:header()});
    return response; 
  }
  catch (error){
    return error.response;
  }
}

export const GetCAOrgAssosiaction = async (obj) => {
  try{
    const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetCAOrgAssociation?caId=${obj}`,{headers:header()});
    return response; 
  }catch (error){
    return error.response;
  }
}

export const GetPosScreenList = async (obj) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetPosScreenList?OrgCode=${obj.OrgCode}&PosTypeId=${obj.PosTypeId}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GetPosRolesList = async (obj) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetPosRolesList?OrgCode=${obj.OrgCode}&SubOrgCode=${obj.SubOrgCode}&PosTypeId=${obj.PosTypeId}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GetPosRoleDetails = async (obj) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetPosRoleDetails?Id=${obj.Id}&OrgCode=${obj.OrgCode}&SubOrgCode=${obj.SubOrgCode}&PosTypeId=${obj.PosTypeId}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const SavePosRolesAndMapping = async (obj, PosTypeId) =>{
  try {
    const response = await axios.post(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/SavePosRoleAndMapping?PosTypeId=${PosTypeId}`, obj,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const ActivateORDeactivatePosRole = async (obj) =>{
  try {
    const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/ActivateORDeactivatePosRole?Id=${obj.Id}&OrgCode=${obj.OrgCode}&SubOrgCode=${obj.SubOrgCode}&IsActivate=${obj.IsActivate}`,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}

export const GetPosScreenListByRoleIds = async (RoleIds, OrgCode, SubOrgCode) =>{
  try {
    const response = await axios.post(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetPosScreenListByRoleIds?OrgCode=${OrgCode}&SubOrgCode=${SubOrgCode}`, RoleIds,{headers:header()});
    return response;
  } catch (error) {
    return error.response
  }
}